import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/(default)/affiliate-program/page.tsx");
